<div
  class="header h-[55px] flex justify-start items-center pl-[50px] bg-[#F1F3F5] overflow-y-hidden"
>
  <p class="!m-0 text-[18px]">{{ projectName }} - Request for Quotation(RFQ)</p>
  <p
    class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
  >
    Tender & select Companies
  </p>
</div>
<div class="!w-full overflow-y-hidden">
  <!-- Tender Type -->
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="mt-[0px] m-[0px] pt-[12px] wrapper">
      <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
        <mat-label>Tender Type</mat-label>
        <mat-select [formControl]="tenderTypeControl" placeholder="Tender Type">
          <!-- Custom Search Input Inside the Mat-Select Dropdown -->
          <div class="search-container" mat-select-header>
            <div class="relative flex">
              <input
                type="text"
                placeholder="Search "
                [formControl]="searchTermControl"
                class="search-input"
              />
              <img
                class="absolute right-[26px] mt-[20px] transform -translate-y-[50%] w-[1.4rem] h-[1.2rem] rounded-full"
                src="assets/icons/search.svg"
                alt="message icon"
              />
            </div>
          </div>
          <!-- Organization Options -->
          <mat-option [value]="'construction works'"
            >Construction Works</mat-option
          >
          <mat-option [value]="'consultancy services'"
            >Consultancy Services</mat-option
          >
        </mat-select>
      </mat-form-field>
      <mat-error
        *ngIf="tenderTypeControl.invalid && tenderTypeControl.touched"
        class="relative top-[-10px]"
      >
        Tender Type is required.
      </mat-error>
    </div>
  </div>

  <!-- Company Selection  -->
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="mt-[0px] m-[0px] wrapper">
      <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
        <mat-label>Company</mat-label>
        <mat-select
          [formControl]="selectedOrganizationControl"
          placeholder="Company"
          style="font-size: 14px !important"
        >
          <!-- Custom Search Input Inside the Mat-Select Dropdown -->
          <div class="search-container" mat-select-header>
            <div class="relative flex">
              <input
                type="text"
                placeholder="Search "
                [formControl]="searchTermControl"
                (input)="filterOrganizationsBySearchTerm()"
                class="search-input"
              />
              <img
                class="absolute right-[26px] mt-[20px] transform -translate-y-[50%] w-[1.4rem] h-[1.2rem] rounded-full"
                src="assets/icons/search.svg"
                alt="message icon"
              />
            </div>
          </div>
          <!-- Organization Options -->
          <ng-container>
            <mat-option
              (click)="externalCompanySelection()"
              [value]="isExtCompany"
              class="hover:!bg-[#fae8e1]"
              style="background: white !important"
              >Other</mat-option
            >
          </ng-container>
          <ng-container *ngFor="let org of filteredOrganizations">
            <mat-option [value]="org" (click)="getOrganizationDetails(org)">
              {{ org?.name }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-error
        *ngIf="
          selectedOrganizationControl?.invalid &&
          selectedOrganizationControl?.touched
        "
        class="relative top-[-10px]"
      >
        Company inclusion is required.
      </mat-error>
    </div>

    <div *ngIf="isExtCompany">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Company Name </mat-label>
          <input
            matInput
            [formControl]="extCompanyNameControl"
            placeholder="Company Name"
            (keydown.enter)="getOrganizationDetails('')"
          />
        </mat-form-field>
        <mat-error
          *ngIf="extCompanyNameControl.invalid && extCompanyNameControl.touched"
          class="relative top-[-10px]"
        >
          Company Name is required.
        </mat-error>
      </div>
    </div>
  </div>

  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Name </mat-label>
          <input matInput [formControl]="nameControl" placeholder="Name" />
        </mat-form-field>
        <mat-error
          *ngIf="nameControl.invalid && nameControl.touched"
          class="relative top-[-10px]"
        >
          Name is required.
        </mat-error>
      </div>
    </div>
  </div>
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Email </mat-label>
          <input matInput [formControl]="emailControl" placeholder="Email" />
        </mat-form-field>
        <mat-error
          *ngIf="emailControl.invalid && emailControl.touched"
          class="relative top-[-10px]"
        >
          <ng-container *ngIf="emailControl.hasError('required')">
            Email is required.
          </ng-container>
          <ng-container *ngIf="emailControl.hasError('email')">
            Please enter a valid email address.
          </ng-container>
        </mat-error>
      </div>
    </div>
  </div>
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Position </mat-label>
          <input
            matInput
            [formControl]="positionControl"
            placeholder="Position"
          />
        </mat-form-field>
        <mat-error
          *ngIf="positionControl.invalid && positionControl.touched"
          class="relative top-[-10px]"
        >
          Position is required.
        </mat-error>
      </div>
    </div>
  </div>
</div>
<div
  class="!pl-[20px] !ml-[30px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
>
  <div class="!w-[429px] flex justify-end items-center">
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="addReceiverOrganizationDetail()"
    >
      Add
    </button>
  </div>
</div>

<div
  class="!pr-[40px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div
    class="!w-[100%] flex"
    style="max-height: calc(40vh - 170px); overflow-y: auto"
  >
    <table
      class="!w-[100%] bg-[#fcfcfd] table-auto !ml-[50px]"
      style="margin-right: 0px"
    >
      <thead
        class="!bg-[#DEE2E6] text-[#343A40] !text-center justify-center !p-[20px] h-[69px] w-full sticky top-0 z-20"
      >
        <tr>
          <th class="px-4 py-2 text-left w-auto">Company</th>
          <th class="px-4 py-2 text-left w-auto">Name</th>
          <th class="px-4 py-2 text-left w-auto">Email</th>
          <th class="px-4 py-2 text-left w-auto">Position</th>
          <th class="px-4 py-2 text-center w-auto">Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr
            *ngFor="let receiverOrg of receiverOrganizationsList; let i = index"
            class="hover:bg-gray-200 border-b-0 items-center justify-center"
            [ngClass]="{
              'bg-white': i % 2 === 0,
              'bg-[#DEE2E6]': i % 2 !== 0
            }"
          >
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ receiverOrg.company_name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ receiverOrg.name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ receiverOrg.email }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ receiverOrg.position }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-center cursor-pointer">
              <button
                type="button"
                class="square-button text-black hover:text-red-600"
                (click)="removeReceiverOrganization(receiverOrg)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="relative bottom-0 right-0 !pr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button (click)="moveToPreviousStep()" type="button" class="back-btn">
      Back
    </button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
      (click)="moveToNextStep()"
    >
      Next
    </button>
  </div>
</div>
